export default __webpack_public_path__ + "static/media/IconDesc_FloodLight.256.8db6223a.png";